import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-color-picker',
    templateUrl: './color-picker.component.html',
    styleUrls: ['./color-picker.component.scss'],
    standalone: false
})
export class ColorPickerComponent implements OnInit {

  public PREDEFINED_COLORS=['#5872f0','#b442d6','#eb1562','#38a19d','#d47f00','#4e64ca','#d18ce6','#f73633','#66c63c','#ff9900','#34c0bc','#30424f','#515665','#a7aab1']
  public color:string;

  constructor(public dialogRef: MatDialogRef<ColorPickerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit(): void {
    this.color = this.data.color;
  }

  onColorChanged($event): void {
  }
  closeDialog() {
    this.dialogRef.close('#555555');
  }
 
}
